import React, { useEffect } from 'react'
import { Button, DialogActions, Typography } from '@mui/material'
import dayjs from 'dayjs'
import 'dayjs/locale/es'

export const FormDelete = (props) => {
    const { onSubmit, item, title  } = props
    const { date, employee, paycodes_day } = item
    const day = dayjs(date)
    const paycodes_ids = paycodes_day.map(p => p.id)

    useEffect(() => {
    }, []);

    return (
        <>
            <Typography variant='body1'>
                {employee} { day.format("L LT") }
            </Typography>
            {paycodes_day.map(p =>
                <Typography variant='body1' key={p.id}>
                    {p.paycode.name} | {p.amount} | {p.note}
                </Typography>
            )}
            <DialogActions sx={{pb: 2, pr: 3}}>
                <Button
                    onClick={() => {onSubmit({props, paycodes_ids})}}
                    color='error'>
                        {title}
                </Button>
            </DialogActions>
        </>
    )
}
